import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ssf-not-found-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
      <h1>404: Not Found</h1>
      <p>Hey! It looks like this page doesn't exist.</p>
  `,
  styles: [
    `
    :host {
      text-align: center;
    }
  `,
  ],
})
export class NotFoundComponent {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/not-found/not-found.component.ts